// extracted by mini-css-extract-plugin
export default {"swapDuration":"1000ms","wrapperClass":"sIsdb0ueTuLAEoR2h_cc"};